import Brand from './Brand';
import Creator from './Creator';
import TikTokLanding from './TikTokLanding';

const index = {
  Brand,
  Creator,
  TikTokLanding,
};

export default index;